import { paralegalSkryt } from '../utils/paralegalScreen';
// File: frontend/src/config/fitenkoNav.js
// Version: 1.0 (quick-260908-pun, окно 1)
// Date: 2026-09-08
// Назначение: ОДНА модель навигации на двух арендаторов.
//   MLG и ELN получают из неё ПРЕЖНИЕ пять выпадающих (проекция `legacyGroups`),
//   fitenko — девять разделов макета (`fitenkoRail` + `subnavFor`).
//
// 🔴 СВЕСТИ МЕНЮ != УДАЛИТЬ СТРАНИЦЫ. Назначений 21, разделов 9, рендерится 8.
//    Ни одно назначение не пропадает: свёрнутое достижимо полосой подраздела.
//
// 🔴 Единственный импорт — правило видимости. Второго держателя прав нет.

import { evalAllow } from './navPermissions';

// 🔴 ОБЕЩАНИЕ СНЯТО И ЗАМЕНЕНО ПРОВЕРЯЕМЫМ ФАКТОМ (quick-260909-v7b).
//    Здесь стояла константа с причиной, по которой раздел History не рендерится:
//    экрана нет. Девять дней это было правдой. В момент появления экрана правда
//    стала ложью, и оставить её было нельзя — а заменить новым обещанием тем
//    более. Вместо обещания стоит ФАКТ, который можно ПРОВЕРИТЬ: маршрут
//    существует, раздел ведёт на него, а отсутствие самой константы сверяется
//    грепом по frontend/src (ворота В12) и под-проверкой П1х сторожа.

// 🔴 Иконки живут ОТДЕЛЬНОЙ картой, а не полем `icon` в строках назначений:
//    `NavDropdown` (Navbar.js:74) рендерит `item.icon`, и проекция без иконок стёрла
//    бы у MLG все 20 иконок пяти выпадающих. Значения перенесены из Navbar.js:123-154
//    и :183 буква в букву.
export const ICONS = {   // ИКОНКИ ПРЕЖНЕГО МЕНЮ — MLG РЕНДЕРИТ ИХ
  cases: '💼',
  leads: '🎯',
  email_inbox: '📧',
  calendar: '📅',
  tasks: '✅',
  client_portal: '🗂️',
  ai_paralegal: '⚖️',
  voice_ai: '🎙️',
  ai_staff: '🤖',
  brain_center: '🧠',
  reputation: '⭐',
  organic_seo: '🌐',
  seo_analytics: '📊',
  billing: '💳',
  doc_generator: '📄',
  magic_deploy: '✨',
  users: '👥',
  audit_log: '📋',
  company_profile: '🏢',
  profile: '👤',
  dashboard: '🏠',
  inbox: '📥',
  ai_ops: '⚡',
  blog: '📰',
  // Ключ нового назначения. П1у требует иконку у КАЖДОГО назначения, а полоса
  // подраздела рисует `item.icon`. У MLG он не рендерится: group === null.
  history: '🕘',
};

// 🔴 `navLinks` от бэкенда перебивает запасной путь ТОЛЬКО у девяти ключей — ровно
//    там, где сегодня зовётся `getPath` (Navbar.js:123-151). Расширение списка на
//    все 21 назначение увело бы `audit_log` на `/admin/audit` (users.py:50), а такого
//    маршрута НЕТ — Audit Log ушёл бы в catch-all у fitenko И у MLG.
export const NAVLINK_KEYS = ['cases', 'leads', 'email_inbox', 'calendar', 'tasks', 'ai_paralegal', 'reputation', 'billing', 'users'];   // ГДЕ СЕГОДНЯ ЗОВЁТСЯ getPath

export const resolvePath = (navLinks, dest) => (NAVLINK_KEYS.includes(dest.key) ? ((navLinks || []).find((l) => l.key === dest.key)?.path || dest.path) : dest.path);

// Связь формы `allow` с ИСХОДНЫМ кодом прежнего меню. Сторож требует, чтобы каждая
// строка отсюда ДОСЛОВНО входила в замороженную физическую строку своего назначения.
export const ALLOW_SOURCE = {   // СВЯЗЬ С ИСХОДНЫМ КОДОМ
  'always': '',
  'tab:cases': "isAllowed('cases')",
  'tab:leads': "isAllowed('leads')",
  'tab:email_inbox': "isAllowed('email_inbox')",
  'tab:calendar': "isAllowed('calendar')",
  'tab:tasks': "isAllowed('tasks')",
  'tab:ai_paralegal': "isAllowed('ai_paralegal')",
  'tab:voice_ai': "isAllowed('voice_ai')",
  'tab:ai_staff': "isAllowed('ai_staff')",
  'tab:brain_center': "isAllowed('brain_center')",
  'tab:reputation': "isAllowed('reputation')",
  'tab:organic_seo': "isAllowed('organic_seo')",
  'tab:billing': "isAllowed('billing')",
  'tab:magic_deploy': "isAllowed('magic_deploy')",
  'tab:users': "isAllowed('users')",
  'role:Client': "userRole === 'Client'",
  'role:Attorney|Creator': "userRole === 'Attorney' || userRole === 'Creator'",
  'role:Creator': "userRole === 'Creator'",
  // 🔴 ПУСТОЕ ЗНАЧЕНИЕ — НЕ ПРОПУСК, А ОТВЕТ. У этой формы нет строки прежнего
  //    меню, из которой её можно было бы вывести: назначение НОВОЕ, прежнего
  //    пункта у него не было. Пустая строка означает «исходной строки нет», и
  //    сторож обязан требовать этого явно, а не пропускать проверку молча.
  //    Шесть меток — зеркало серверного рубежа: STAFF_ROLE_NAMES (deps.py) даёт
  //    CREATOR, SUPERADMIN, ADMINISTRATOR, MANAGING_PARTNER, ATTORNEY, PARALEGAL,
  //    и getUserRoleLabel называет их Creator, Super Admin, Partner, Admin,
  //    Attorney, Paralegal. Client и User не проходят ни там, ни здесь.
  'role:Creator|Super Admin|Partner|Admin|Attorney|Paralegal': '',
};

// 🔴 Двадцать одно назначение. Поля `icon` здесь НЕТ намеренно — см. карту ICONS.
//    `seo_analytics` несёт `tab:organic_seo`, а не `tab:seo_analytics`: в Navbar.js:141
//    оба пункта закрыты ОДНИМ `isAllowed('organic_seo')`; выдумать второй ключ значило
//    бы СУЗИТЬ права молча.
//    `billing` мёртв: маршрута `/billing` в App.js нет. Мёртвое множество НЕ
//    объявляется, а ВЫЧИСЛЯЕТСЯ сторожем как {итоговые пути} − {маршруты App.js};
//    флаг `dead` — лишь заявка, которую сторож сверяет с вычислением.
export const LEGACY_DESTINATIONS = [
  { key: 'dashboard',       label: 'Dashboard',       path: '/dashboard',             allow: 'always',                group: 'top',      section: 'today' },
  { key: 'cases',           label: 'Cases',           path: '/cases',                 allow: 'tab:cases',             group: 'business', section: 'cases' },
  { key: 'leads',           label: 'Leads',           path: '/leads',                 allow: 'tab:leads',             group: 'business', section: 'clients' },
  { key: 'email_inbox',     label: 'Email Inbox',     path: '/email-inbox',           allow: 'tab:email_inbox',       group: 'business', section: 'inbox' },
  { key: 'calendar',        label: 'Calendar',        path: '/calendar',              allow: 'tab:calendar',          group: 'business', section: 'calendar' },
  { key: 'tasks',           label: 'Tasks',           path: '/tasks',                 allow: 'tab:tasks',             group: 'business', section: 'today' },
  { key: 'client_portal',   label: 'My Portal',       path: '/client-portal',         allow: 'role:Client',           group: 'business', section: 'today' },
  { key: 'ai_paralegal',    label: 'AI Paralegal',    path: '/ai-paralegal',          allow: 'tab:ai_paralegal',      group: 'ai',       section: 'ai_ops' },
  { key: 'voice_ai',        label: 'Voice AI',        path: '/voice',                 allow: 'tab:voice_ai',          group: 'ai',       section: 'ai_ops' },
  { key: 'ai_staff',        label: 'AI Staff',        path: '/ai-staff',              allow: 'tab:ai_staff',          group: 'ai',       section: 'ai_ops' },
  { key: 'brain_center',    label: 'Brain Center',    path: '/admin/brain',           allow: 'tab:brain_center',      group: 'ai',       section: 'ai_ops' },
  { key: 'reputation',      label: 'Reputation',      path: '/reputation',            allow: 'tab:reputation',        group: 'seo',      section: 'growth' },
  { key: 'organic_seo',     label: 'Organic SEO',     path: '/organic-seo',           allow: 'tab:organic_seo',       group: 'seo',      section: 'growth' },
  { key: 'seo_analytics',   label: 'SEO Analytics',   path: '/seo-analytics',         allow: 'tab:organic_seo',       group: 'seo',      section: 'growth' },
  { key: 'billing',         label: 'Billing',         path: '/billing',               allow: 'tab:billing',           group: 'tools',    section: null, dead: true },
  { key: 'doc_generator',   label: 'Doc Generator',   path: '/document-generator',    allow: 'role:Attorney|Creator', group: 'tools',    section: 'cases' },
  { key: 'magic_deploy',    label: 'Magic Deploy',    path: '/magic-executor',        allow: 'tab:magic_deploy',      group: 'tools',    section: 'settings' },
  { key: 'users',           label: 'Users',           path: '/user-management',       allow: 'tab:users',             group: 'admin',    section: 'settings' },
  { key: 'audit_log',       label: 'Audit Log',       path: '/admin/audit-log',       allow: 'role:Creator',          group: 'admin',    section: 'settings' },
  { key: 'company_profile', label: 'Company Profile', path: '/admin/company-profile', allow: 'role:Creator',          group: 'admin',    section: 'settings' },
  { key: 'profile',         label: 'Profile',         path: '/profile',               allow: 'always',                group: 'admin',    section: 'settings' },
  // 🔴 ПЕРВОЕ ПО-НАСТОЯЩЕМУ НОВОЕ НАЗНАЧЕНИЕ. Прежние двадцать одно — проекция
  //    прежнего меню MLG, и сторож морозил их построчно. У этого замороженной
  //    строки НЕТ И БЫТЬ НЕ МОЖЕТ: экран заведён здесь, а не перенесён.
  //    `group: null` — не небрежность: `legacyGroups` фильтрует по пяти именам
  //    групп, и `null` не совпадёт ни с одним. Иначе у MLG в выпадающих появился
  //    бы семнадцатый пункт, а обещано «ни на пиксель».
  //    🔴 ФОРМА `role:` ВЫБРАНА НЕ ДЛЯ КРАСОТЫ. Формы `tab:` читают
  //    `allowed_tabs` РАНЬШЕ ролей (navPermissions.isAllowedByKey), то есть
  //    вторая дверь открыла бы этот экран мимо роли кому угодно. Экран отдаёт
  //    ленту ВСЕЙ ФИРМЫ; его рубеж обязан быть ролевым и совпадать с серверным
  //    `get_current_staff_user` — шесть штатных ролей, CLIENT и LEAD не входят.
  { key: 'history',         label: 'History',         path: '/history',               allow: 'role:Creator|Super Admin|Partner|Admin|Attorney|Paralegal', group: null, section: 'history' },
  { key: 'inbox',           label: 'Inbox',           path: '/inbox',                 allow: 'tab:email_inbox',       group: null, section: 'inbox' },
  { key: 'ai_ops',          label: 'AI Operations',   path: '/ai-ops',                allow: 'tab:ai_paralegal',      group: null, section: 'ai_ops' },
  { key: 'blog',            label: 'Blog',            path: '/blog',                  allow: 'tab:reputation',        group: null, section: 'blog' },
];

// Девять разделов §2 макета. С quick-260909-v7b рендерятся ВСЕ ДЕВЯТЬ: у History
// появился экран, и раздел ведёт на него. Пустых разделов не осталось ни одного.
export const FITENKO_SECTIONS = [
  { id: 'today', label: 'Today', dests: ['dashboard', 'tasks', 'client_portal'] },
  { id: 'calendar', label: 'Calendar', dests: ['calendar'] },
  { id: 'inbox', label: 'Inbox', dests: ['inbox', 'email_inbox'] },
  // 🔴 Д-01: раздел назван `Leads`, а не `Clients`. Лид не клиент — с клиентом
  //    связаны проверка конфликта интересов и адвокатская тайна, и назвать 109
  //    обращений клиентами нельзя (`CONVERTED` на бою — 2). Имя `Clients`
  //    вернётся сюда вместе с НАСТОЯЩИМ экраном клиентов, а не раньше.
  //    Расхождение с атласом НАРОЧНОЕ и записано отдельной строкой в SUMMARY.
  { id: 'clients', label: 'Leads', dests: ['leads'] },
  { id: 'cases', label: 'Cases', dests: ['cases', 'doc_generator'] },
  { id: 'history', label: 'History', dests: ['history'] },
  { id: 'ai_ops', label: 'AI Operations', dests: ['ai_ops', 'ai_paralegal', 'voice_ai', 'ai_staff', 'brain_center'] },
  { id: 'growth', label: 'Growth Center', dests: ['reputation', 'organic_seo', 'seo_analytics'] },
  { id: 'blog', label: 'Blog', dests: ['blog'] },
  { id: 'settings', label: 'Settings', dests: ['profile', 'users', 'audit_log', 'company_profile', 'magic_deploy'] },
];

const byKey = (k) => LEGACY_DESTINATIONS.find((d) => d.key === k);

// 🔴 `!!d` — не проглатывание, а разделение ролей: раздел, сославшийся на
//    НЕСУЩЕСТВУЮЩИЙ ключ, не должен ронять всю модель молчаливым TypeError; он
//    обязан быть НАЗВАН, и называет его сторож (П1в — «висячая ссылка раздела»).
const isVisible = (user, d) => !!d && evalAllow(user, d.allow);

const visibleDests = (user, section) => section.dests.map(byKey).filter((d) => isVisible(user, d));

const project = (navLinks, d) => ({
      key: d.key,
      label: d.label,
      icon: ICONS[d.key],
      path: resolvePath(navLinks, d),
});

// Путь раздела = ПЕРВОЕ ВИДИМОЕ назначение, а не зашитое: у пользователя без
// `ai_paralegal`, но с `voice_ai`, AI Operations обязан вести на `/voice`.
export const sectionPath = (user, navLinks, section) => {
    const shown = visibleDests(user, section);
    return shown.length === 0 ? null : resolvePath(navLinks, shown[0]);   // ПЕРВОЕ ВИДИМОЕ
};

// Раздел ВИДИМ <=> видимо хотя бы одно его назначение.
export const fitenkoRail = (user, navLinks, features) => FITENKO_SECTIONS
    .filter((s) => s.id !== 'blog' || !!features?.blog)
    .map((s) => ({ id: s.id, label: s.label, path: sectionPath(user, navLinks, s) }))
    .filter((s) => s.path !== null);

// Мёртвые в префиксы не попадают: вести на них некуда.
export const PREFIXES = LEGACY_DESTINATIONS
    .filter((d) => !d.dead && d.section)
    .map((d) => ({ path: d.path, section: d.section }))
    .sort((a, b) => b.path.length - a.path.length);   // САМЫЙ ДЛИННЫЙ ПРЕФИКС

export const sectionOf = (pathname) => {
    const matched = PREFIXES.filter((p) => pathname === p.path || pathname.startsWith(p.path + '/'));
    return matched.length === 0 ? null : matched[0].section;
};

// Полоса подраздела показывает ВСЕ видимые назначения активного раздела —
// именно она делает достижимым свёрнутое при сведении 20 пунктов в 9.
export const subnavFor = (user, navLinks, pathname, features) => {
    const id = sectionOf(pathname);
    const section = FITENKO_SECTIONS.find((s) => s.id === id);
    return section ? visibleDests(user, section)
        .filter((d) => !(paralegalSkryt(features) && d.key === 'ai_paralegal'))
        .filter((d) => !(d.key === 'blog' && !features?.blog))
        .map((d) => project(navLinks, d)) : [];
};

const LEGACY_GROUPS = ['business', 'ai', 'seo', 'tools', 'admin'];

// Прежние пять выпадающих СТРОЯТСЯ фильтром по `group`, а не переписываются заново.
export const legacyGroups = (user, navLinks, features) => {
    const out = {};
    for (const g of LEGACY_GROUPS) {
        out[g] = LEGACY_DESTINATIONS.filter((d) => {
            if (d.group !== g || !isVisible(user, d)) return false;
            if (paralegalSkryt(features) && d.key === 'ai_paralegal') return false;
            return true;
        }).map((d) => project(navLinks, d));
    }
    return out;
};

// ═════════════════════════════════════════════════════════════════════════════
// ГРУППЫ КОЛОННЫ (quick-260909-qa3)
// ═════════════════════════════════════════════════════════════════════════════
// 🔴 RAIL_GROUPS — ЕДИНСТВЕННЫЙ держатель заголовков групп и порядка разделов.
//    Компонент колонки своих меток не держит и держать не должен: вторая копия
//    завела бы второе мнение о том, что как называется.
export const RAIL_GROUPS = [
  { id: 'home',     label: 'HOME',        sections: ['today'] },
  { id: 'work',     label: 'WORK',        sections: ['calendar', 'inbox'] },
  { id: 'practice', label: 'PRACTICE',    sections: ['clients', 'cases', 'history'] },
  { id: 'growth',   label: 'AI & GROWTH', sections: ['ai_ops', 'growth', 'blog'] },
  { id: 'tail',     label: null,          sections: ['settings'] },   // ХВОСТ БЕЗ ЗАГОЛОВКА
];

// 🔴 `history` перечислен в PRACTICE с самого начала: пока экрана не было,
//    группа обязана была уцелеть без него, а теперь он в ней рендерится.
//    Раздел, не попавший НИ В ОДНУ группу, ИСЧЕЗ БЫ ИЗ КОЛОННЫ МОЛЧА. Поэтому
//    утверждение не написано словами в комментарии, а ЭКСПОРТИРОВАНО функцией:
//    его можно ИСПОЛНИТЬ, и ворота задачи 4 это делают.
export const sectionsOutsideGroups = () => {
    const vGruppah = new Set(RAIL_GROUPS.reduce((acc, g) => acc.concat(g.sections), []));
    return FITENKO_SECTIONS.map((s) => s.id).filter((id) => !vGruppah.has(id));
};

// Раскладывает УЖЕ ПОСТРОЕННЫЙ список разделов по группам. Правило видимости
// НЕ ПЕРЕПИСЫВАЕТСЯ — на вход подаётся результат `fitenkoRail`.
// 🔴 Пустая группа ВЫБРАСЫВАЕТСЯ: заголовок над пустотой — заголовок ни над чем.
export const groupRail = (rail) => {
    const byId = new Map((rail || []).map((s) => [s.id, s]));
    return RAIL_GROUPS
        .map((g) => ({ id: g.id, label: g.label, items: g.sections.map((id) => byId.get(id)).filter(Boolean) }))
        .filter((g) => g.items.length > 0);   // ПУСТЫЕ ГРУППЫ НЕ РИСУЮТСЯ
};

export const fitenkoRailGrouped = (user, navLinks, features) => groupRail(fitenkoRail(user, navLinks, features));
